/*
  ms-bundle-3for2.js — Mile Sports 3-for-2, pris-ledet visning i PDP-bundle-widgeten.

  Panelet leder altid med "Køb 3, betal for 2" + prisen. Store-rabatten
  ("Mile Sports: 3 for 2 (billigste gratis)" — køb 2 fra mile-sports, få 1 gratis) anvendes i
  kurv/checkout; her projiceres den ved varevalg, så kunden ser prisen FØR den lægges i kurv.

  Additivt: læser data-price (holdt frisk af theme.js ProductBundlePicker) + lytter på
  bundle:change og section-change. Rører ikke theme.js.

  Spejler også den rabatterede total ind i <product-buy-price> (ATC-knappens pris) —
  theme.js' ProductBuyPrice skriver fuld sum synkront på bundle:change; denne kører i
  rAF og lander derfor altid efter, så knappen viser prisen inkl. 3-for-2.
*/
(function () {
  function money(cents) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      var format = theme.settings.currencyCodeEnabled ? theme.settings.moneyWithCurrencyFormat : theme.settings.moneyFormat;
      return theme.Currency.formatMoney(cents, format);
    }
    try {
      return (cents / 100).toLocaleString('da-DK', { style: 'currency', currency: 'DKK' });
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  class MsBundle3for2 {
    constructor(panel) {
      this.panel = panel;
      this.section = panel.closest('.shopify-section') || document;
      this.mainPrice = parseInt(panel.getAttribute('data-main-price'), 10) || 0;

      const details = this.section.querySelector('[is="product-bundle-details"]');
      const formId = details && details.getAttribute('form');
      this.form = (formId && document.getElementById(formId)) ||
                  this.section.querySelector('form[action*="/cart/add"]');

      this.elOriginal = panel.querySelector('[data-ms-b3-original]');
      this.elDiscounted = panel.querySelector('[data-ms-b3-discounted]');
      this.elSave = panel.querySelector('[data-ms-b3-save]');
      this.elSavings = panel.querySelector('[data-ms-b3-savings]');

      this.update = this.update.bind(this);
      this._compute = this._compute.bind(this);

      this.section.addEventListener('change', this.update);
      if (this.form) this.form.addEventListener('bundle:change', this.update);
      document.addEventListener('bundle:change', this.update);

      this.update();
    }

    update() {
      // rAF: read data-price AFTER theme.js ProductBundlePicker writes the new variant price
      window.requestAnimationFrame(this._compute);
    }

    _compute() {
      // hovedproduktets pris læses live fra <product-buy-price data-price> (holdes frisk
      // af theme.js ved variant-skift); Liquid-værdien fra load er kun fallback
      const buyPriceEls = Array.from(this.section.querySelectorAll('product-buy-price'));
      const livePrice = buyPriceEls.length ? parseInt(buyPriceEls[0].getAttribute('data-price'), 10) : NaN;
      const mainPrice = isNaN(livePrice) ? this.mainPrice : livePrice;

      const items = [{ price: mainPrice, row: null }];
      this.section.querySelectorAll('input[name="bundles"]:checked').forEach((input) => {
        const price = parseInt(input.getAttribute('data-price'), 10);
        if (!isNaN(price)) items.push({ price: price, row: input.closest('.product-bundle__info') });
      });

      const n = items.length;
      const freeCount = Math.floor(n / 3);
      // cheapest first; on price ties prefer items that have a row, so a visible
      // "Gratis" marker lands on a bundle item rather than the rowless main product
      const sorted = items.slice().sort((a, b) => (a.price - b.price) || ((a.row ? 0 : 1) - (b.row ? 0 : 1)));
      const freeSet = new Set(sorted.slice(0, freeCount));
      const subtotal = items.reduce((sum, it) => sum + it.price, 0);
      const savings = sorted.slice(0, freeCount).reduce((sum, it) => sum + it.price, 0);
      const discounted = subtotal - savings;

      // reset previous free markers
      this.section.querySelectorAll('.product-bundle__info.ms-bundle-free').forEach((row) => {
        row.classList.remove('ms-bundle-free');
        const tag = row.querySelector('.ms-bundle-free-tag');
        if (tag) tag.remove();
      });
      // mark the cheapest free rows (main product has no row, so it just lowers the total)
      items.forEach((it) => {
        if (it.row && freeSet.has(it)) {
          it.row.classList.add('ms-bundle-free');
          const slot = it.row.querySelector('.horizontal-product__quantity') || it.row;
          if (!slot.querySelector('.ms-bundle-free-tag')) {
            const tag = document.createElement('span');
            tag.className = 'ms-bundle-free-tag';
            tag.textContent = '0 kr';
            slot.appendChild(tag);
          }
        }
      });

      // price-led render: total is always shown; strikethrough + savings only when a free item applies
      this.panel.hidden = false;
      if (this.elDiscounted) this.elDiscounted.textContent = money(discounted);
      // ATC-knappen skal vise samme rabatterede total (overskriver theme.js' fulde sum)
      buyPriceEls.forEach((el) => { el.innerHTML = money(discounted); });
      if (freeCount >= 1) {
        if (this.elOriginal) { this.elOriginal.textContent = money(subtotal); this.elOriginal.hidden = false; }
        if (this.elSavings) this.elSavings.textContent = money(savings);
        if (this.elSave) this.elSave.hidden = false;
      } else {
        if (this.elOriginal) this.elOriginal.hidden = true;
        if (this.elSave) this.elSave.hidden = true;
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-ms-bundle-3for2]').forEach((panel) => {
      if (!panel.__msB3) panel.__msB3 = new MsBundle3for2(panel);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
